import React from "react";
import { Button, Spinner } from "reactstrap";

const ModalFooterButtons = ({
  activeStep,
  handlePrev,
  handleNext,
  paymentMethod,
  handleAddTip,
  loader,
  color,
}) => (
  <div className="d-flex justify-content-between my-3 px-3">
    <Button
      disabled={activeStep === 1}
      onClick={handlePrev}
      style={{
        backgroundColor: "#e0e0e0",
        color: "#333",
        border: "none",
        padding: "10px 24px",
        borderRadius: "8px",
        fontWeight: 500,
        minWidth: "120px",
      }}
    >
      Prev
    </Button>

    {activeStep < 2 ? (
      <Button
        onClick={handleNext}
        style={{
          backgroundColor: color,
          color: "#fff",
          border: "none",
          padding: "10px 24px",
          borderRadius: "8px",
          fontWeight: 600,
          minWidth: "120px",
        }}
      >
        Next
      </Button>
    ) : (
      !["Stripe", "Paypal"].includes(paymentMethod) && (
        <Button
          onClick={handleAddTip}
          disabled={paymentMethod !== "cash"}
          style={{
            backgroundColor: color,
            color: "#fff",
            border: "none",
            padding: "10px 24px",
            borderRadius: "8px",
            fontWeight: 600,
            minWidth: "120px",
          }}
        >
          {loader ? <Spinner size="sm" color="light" /> : "Submit"}
        </Button>
      )
    )}
  </div>
);

export default ModalFooterButtons;
